import { useNavigate } from 'react-router-dom';

import './styles.css';

import Layout from '../../UI/introGameLayout/layout';

export default function InstructorOnboardingAllSet() {
  const navigate = useNavigate();

  const handleGotItClick = () => {
    navigate('/instructor/settings/assignments');
  }

  return (
    <Layout
      isHeaderVisible={true}
      isContentVertical={true}
      className="instructor-onboarding-layout"
    >
      <div className="instructor-onboarding-all-set-container">
        <h1>You’re all set!</h1>
        <h2>Before assigning to students, make sure to: </h2>
        <ul>
          <li><b>Review</b> each default assignment and ensure that the accounts and transactions selected are the ones you want your students to see. If not, customize as you see fit.</li> 
          <li><b>Check with IT</b> to ensure your class can access to our site. They can confirm this by visiting the game site and logging in using a student account.</li>
        </ul>
        <h2>After assigning to students, make sure to:</h2>
        <ul>
          <li><b>Monitor Progress, Performance, and Scores</b> from the insights pages. It’s where to go to review class performance and spot learning gaps. You can also monitor progress and scores in this section.</li>
          <li><b>Leverage the Leaderboard to Drive Engagement</b> if you use in class, utilize the Leaderboard. Seeing the page will further motivate them to complete the exercise</li>
        </ul>
        <button onClick={handleGotItClick}>Got it</button>
      </div>
    </Layout>
  );
}
